class PopupMessage {
    constructor() {
        this._init()
    }
    _init() {
        document.querySelectorAll('.popup-message').forEach(function (el) {
            setTimeout(function () {
                el.classList.add('--open')
            }, 1000)
            el.addEventListener('click', function () {
                el.classList.add('--hidden')
                // end animation
                setTimeout(function () {
                    el.remove()
                }, 1000)
            }, true)
        });
    }
}

export default PopupMessage